import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import personalSavingAccontImage from "../../assets/static/personal/wallet_ui.png";

function SavingsAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Savings Account? We’ve got you covered."
        description="Kontriman offers various ways to assist you with your savings account – via our help center, chat support, and email. Get the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />
      <div>
      <Container fluid className="my-5 bg-custom">
      <Container className="container-padding">
      <Row className="flex-column flex-md-row">
        {/* Text column */}
        <Col md={6} className="order-1 order-md-2 d-flex align-items-center">
          <div>
            <h1 className="custom_heading">Personal Saving Account</h1>
            <p>
              Our Personal Saving Account helps you grow your money securely
              while providing easy access when needed. Whether you're saving for
              a goal or just building a safety net, enjoy flexibility and peace
              of mind with every deposit.
            </p>

            <h5 className="mt-4">Features & Benefits</h5>
            <ul>
              <li>Attractive interest rates</li>
              <li>No monthly maintenance fees</li>
              <li>Easy deposits and withdrawals</li>
              <li>Online and mobile banking access</li>
            </ul>

            <h5 className="mt-4">Eligibility</h5>
            <ul>
              <li>Valid national ID or passport</li>
              <li>Proof of address</li>
              <li>Minimum age: 18 years</li>
            </ul>

            <a href="mailto:info@kontriman.com">
              <Button className="custom-button mt-3">Open Account</Button>
            </a>
          </div>
        </Col>

        {/* Image column */}
        <Col md={6} className="order-2 order-md-1">
          <img
            src={personalSavingAccontImage}
            alt="Personal Saving Account"
            className="img-fluid"
          />
        </Col>
      </Row>
          </Container>
          </Container>
      <Footer></Footer>
    </div>
    </div>
  );
}

export default SavingsAccount;
